module.exports = __webpack_public_path__ + "static/media/UN043869.a43b527b.jpg";